module.exports = __webpack_public_path__ + "img/CY.a0053fe6.png";